import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { Download } from "lucide-react";
import Sidebar from "../../../components/Sidebar";
import TopBar from "../../../components/TopBar";
import "../index.css";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload } from "antd";
import { Checkbox, Form, Input, Button, Modal } from "antd";
import { uploadBulkCounsellor } from "../../../api/Upload/Counsellor/index";
import { addCounsellor } from "../../../api/Upload/Counsellor/addCounsellor";
import { useDispatch } from "react-redux";
import success from "../../../../../assets/images/success.png";
const { Dragger } = Upload;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export default function Index() {
  const [file, setFile] = useState(null);
  const [show, setShow] = useState(false);
  const [failed_count, setFailed_count] = useState(0);
  const [failedUrl, setFailedUrl] = useState("");
  const [fileList, setFileList] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();

  const onFinish = (values) => {
    console.log("Success:", values);
    let data = {
      firstName: values.firstname,
      lastName: values.lastname,
      email: values.email,
    };
    dispatch(addCounsellor(JSON.stringify(data))).then((res) => {
      if (res.payload.status === "success") {
        setShow(true);
        setFile(null);
      } else if (res.payload.message.error === "invalid_token") {
        message.error("Please login");
        window.location.href = "/";
      } else {
        message.error(res.payload.message.payload);
      }
    });
  };

  const uplaodFile = () => {
    if (file === null) {
    } else {
      let token = localStorage.getItem("token");
      let data = {
        token: "Bearer " + token,
        file: file,
      };
      dispatch(uploadBulkCounsellor(data)).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          setShow(true);
          setFile(null);
          setFailed_count(res.payload.message.payload.failure_count);
          if (res.payload.message.payload.total_count > 0) {
            setFailedUrl(res.payload.message.payload.failure_file_name);
          }
        } else if (res.payload.message.error === "invalid_token") {
          message.error("Session expired. Please login again");
          window.location.href = "/";
        } else {
          message.error(res.payload.message.payload);
        }
      });
    }
  };
  const onChange = (info) => {
    const latestFileList = info.fileList.slice(-1);
    setFileList(latestFileList);

    if (latestFileList.length > 0) {
      const file = latestFileList[0];
      const originFile = file.originFileObj;
      setFile(originFile);
      if (originFile) {
        console.log("Native file object:", originFile);
        // You can now use `originFile` to read file content or upload manually
      }
    }
  };

  const downloadSample = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/sample/download?fileIdentifier=BULK_COUNSELLOR_SAMPLE_FILE`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ` + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch the file");
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = "BULK_UPLOAD_PRACTITIONER.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };
  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl font-poppins">
          {localStorage.getItem("role") === "ADMIN" ? (
            <div className="create-form-box w-full p-[24px] bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl shadow-sm">
              <Form
                name="complex-form"
                layout="vertical"
                onFinish={onFinish}
                labelCol={{
                  span: 32,
                }}
                wrapperCol={{
                  span: 64,
                }}
                style={{
                  width: "100%",
                }}
              >
                <Form.Item
                  style={{
                    marginBottom: 0,
                    width: "100%",
                  }}
                >
                  <Form.Item
                    label={
                      <span style={{ fontFamily: "Poppins" }}>
                        Practitioner Firstname
                      </span>
                    }
                    name="firstname"
                    rules={[
                      {
                        required: true,
                        message: "Practitioner firstname is required",
                      },
                    ]}
                    style={{
                      display: "inline-block",
                      width: "calc(22% - 8px)",
                      fontFamily: "Poppins",
                    }}
                  >
                    <Input
                      placeholder="Practitioner Firstname"
                      style={{
                        width: "100%",
                        height: "45px",
                        fontFamily: "Poppins",
                        borderRadius: "12px",
                        border: "1px solid #E2E8F0",
                        color: "#171717",
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={
                      <span style={{ fontFamily: "Poppins" }}>
                        Practitioner Lastname
                      </span>
                    }
                    name="lastname"
                    rules={[
                      {
                        required: true,
                        message: "Practitioner lastname is required",
                      },
                    ]}
                    style={{
                      display: "inline-block",
                      width: "calc(22% - 8px)",
                      margin: "0 8px",
                    }}
                  >
                    <Input
                      placeholder="Practitioner Lastname"
                      style={{
                        width: "100%",
                        height: "45px",
                        fontFamily: "Poppins",
                        borderRadius: "12px",
                        border: "1px solid #E2E8F0",
                        color: "#171717",
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={
                      <span style={{ fontFamily: "Poppins" }}>
                        Practitioner Email
                      </span>
                    }
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Practitioner email is required",
                      },
                    ]}
                    style={{
                      display: "inline-block",
                      width: "calc(22% - 8px)",
                    }}
                  >
                    <Input
                      placeholder="Practitioner Email address"
                      style={{
                        width: "100%",
                        height: "45px",
                        fontFamily: "Poppins",
                        borderRadius: "12px",
                        border: "1px solid #E2E8F0",
                        color: "#171717",
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    label={null}
                    style={{
                      display: "inline-block",
                      width: "calc(22% - 8px)",
                      margin: "0 8px",
                    }}
                  >
                    <Button
                      className="submit-btn btn-gradient text-[13px] font-semibold rounded-xl border-0 font-poppins"
                      htmlType={"submit"}
                      style={{
                        width: "100%",
                        height: "45px",
                        marginTop: "30px",
                      }}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </Form.Item>
              </Form>
            </div>
          ) : null}
          <br></br>
          <div className="download-dummy-box flex items-center justify-between gap-3 w-full p-[24px] bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl shadow-sm">
            <span className="download-text text-base font-semibold text-[#171717] font-poppins">
              Download the template for bulk upload
            </span>
            <Button
              className="download-btn flex items-center justify-center h-9 w-9 p-0 bg-white text-[#2563EB] border-[1px] border-solid border-[#E2E8F0] rounded-xl shadow-sm hover:bg-[#F8FAFC]"
              onClick={() => downloadSample()}
            >
              <Download size={18} />
            </Button>
          </div>
          <div className="upload-data-box flex flex-col gap-3 w-full mt-3 p-[24px] bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl shadow-sm">
            <Dragger
              accept=".xlsx"
              onChange={onChange}
              showUploadList={true}
              beforeUpload={() => false}
              multiple={false}
              fileList={fileList}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
              <p className="ant-upload-hint">
                Support for a single upload. Strictly prohibited from uploading
                company data or other banned files.
              </p>
            </Dragger>
            {localStorage.getItem("role") === "ADMIN" ? (
              <Button className="submit-btn btn-gradient self-end h-9 px-[14px] text-[13px] font-semibold rounded-xl border-0 font-poppins" onClick={() => uplaodFile()}>
                Submit
              </Button>
            ) : null}
          </div>
        </div>
      </div>
      <Modal
        open={show}
        onCancel={() => setShow(!show)}
        footer={null}
        className="custom-modal text-center"
      >
        {failed_count > 0 ? null : (
          <Image
            src={success}
            style={{
              width: "45px",
              height: "45px",
              display: "inline-block",
            }}
          />
        )}

        <br></br>
        <br></br>
        {failed_count > 0 ? (
          <>
            <span className="success-text">
              <span style={{ color: "#2563EB" }}>Ohh!!</span> There is some
              issue with file please check
            </span>
            <br></br>
            <Button
              href={failedUrl}
              target={"_blank"}
              rel={"noreferrer"}
              className="login-continue"
              style={{
                width: "50%",
              }}
            >
              View File
            </Button>
          </>
        ) : (
          <>
            <span className="success-text">
              <span style={{ color: "#2563EB" }}>Congratulation!!</span> Your
              Practitioners Data is added to Practitioners list. Please check
            </span>
            <br></br>
          </>
        )}

        <br></br>
        <br></br>
      </Modal>
    </div>
  );
}
